<template>
  <div>
    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" :data="qianshuData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">

          <el-table-column  prop="receiverInfo" label="收货人信息" width="240px"></el-table-column>
          <el-table-column  prop="buyerMessage" label="买家留言" width="160px"></el-table-column>
          <el-table-column  prop="sellerMemo" label="卖家备注" width="160px"></el-table-column>
          <el-table-column label="主图"  width="100px">
            <template slot-scope="scope" >
              <img  width="100px" height="100px" :src="scope.row.picPath+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column  prop="color" label="颜色" width="200px"></el-table-column>
          <el-table-column  prop="size" label="尺码" width="200px"></el-table-column>
          <el-table-column  prop="waikuang" label="外框类型" width="200px"></el-table-column>
          <el-table-column  prop="num" label="数量" ></el-table-column>
          <el-table-column  prop="statusChn" label="退款状态" ></el-table-column>
          <el-table-column  v-if="showFlag=='1'" prop="sellerFlag" label="备注旗帜" ></el-table-column>
          <el-table-column  v-if="showZuhe=='1'" prop="zuhe" label="组合形式" width="200px"></el-table-column>

        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "QianShu",
    data() {
      return {
        display:1,
        showZuhe:'0',
        showFlag:'1',
        qianshuData:[],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 10
        },
      }
    },
    methods:{
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
        }

      },
      indexMethod(index)
      {
        return index + 1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getQianshuData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getQianshuData();
      },
      getQianshuData:function () {
        let param={
          nick: storage.get("nick"),
          sellerFlag:-1
        }
        $api.post("/custom/qianshu",param, response=>{
          let dataResult = response.data;
          if(dataResult.state == 1 && dataResult.message=="ok"){
            this.qianshuData = dataResult.data.qianshu;
            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }else{
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      }
    },
    mounted(){
      let nick=storage.get("nick");
      if ((nick == "yang15968894410") || (nick == "yanghuanha")|| (nick == "墙悦旗舰店") ){
        this.showFlag="0";
      }
      if(nick == "dumma旗舰店"){
        this.showZuhe ="1";
      }
      this.getQianshuData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/QianShu.vue